





































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    components: {
    },
    ...mapGetters(["accountBook"])
})
export default class ChangeEditSub extends Vue {
    @Prop({ type: Object })
    editSubjectForm?: EditSubject;

    @Prop({ type: Number })
    saveType?: number;

    @Prop({ type: Array })
    types?: string[];

    assModels: any = {};
    assistList: Assist.AssistAccount[] = [];

    mounted() {
        // 初始化下拉对象的值
        if (this.types) {
            this.types.forEach((e: string, index: number) => {
                (<any>this.assistList)[e] = [];
                (<any>this.assModels)[e] = null;
                this.getAssistList(e)
            });
        }
    }

    // 获取科目数据
    getAssistList(name: string) {
        let accountName = name.toString()
        Vue.axios
            .post(`dim/find?accountBookId=${
                this.$store.state.accountBook.id
                }&dimAccountType=${accountName}`)
            .then(res => {
                (<any>this.assistList)[name] = res.data;
                this.$forceUpdate()
            });
    }

    // 取消
    close() {
        this.$emit("close")
    }
    // 确定提交
    confirmTrans() {
        if (!this.isDisable()) {
            if (this.saveType) {
                if (this.saveType < 3) {
                    this.updateItem(true, (response: any) => {
                        if (this.saveType == 1) {
                            this.$emit("success")
                        } else if (this.saveType == 2) {
                            this.$emit("close")
                        }
                    });
                } else {
                    if (this.saveType == 3) this.updateEdit(true);
                    else this.updateEdit(false);
                }
            }
        }
    }
    // 新增数据提交
    updateItem(isTrans: boolean, next: any) {
        if (this.editSubjectForm) {
            Vue.axios
                .post(`subjects/` + this.editSubjectForm.id + `/savecreate`, {
                    no: this.editSubjectForm.subjectCode,
                    text: this.editSubjectForm.subjectName,
                    measuringUnit: this.editSubjectForm.measuringUnit,
                    currSymbol: this.editSubjectForm.currSymbol,
                    dimAccountTypes: this.types,
                    relation: isTrans ? this.getRelation() : null
                })
                .then(res => {
                    next(res);
                });
        }
    }
    // relation 赋值
    getRelation() {
        let obj: any = {};
        if (this.types) {
            this.types.forEach((v: any, i: number) => {
                let attr = this.transRelation(v);
                obj[attr] = this.assModels[v].id;
            });
        }
        return obj;
    }
    // 循环数据
    transRelation(val: string) {
        switch (val) {
            case "项目":
                return "dimItemId";
            case "客户":
                return "dimCustomerId";
            case "部门":
                return "dimDepartmentId";
            case "员工":
                return "dimEmployeeId";
            case "存货":
                return "dimInventoryId";
            case "供应商":
                return "dimProviderId";
            default:
                return "dimItemId";
        }
    }
    // 编辑科目请求接口
    updateEdit(isTrans: boolean) {
        if (this.editSubjectForm) {
            Vue.axios
                .post(`subjects/` + this.editSubjectForm.id + `/modify`, {
                    no: this.editSubjectForm.subjectCode,
                    text: this.editSubjectForm.subjectName,
                    measuringUnit: this.editSubjectForm.measuringUnit,
                    currSymbol: this.editSubjectForm.currSymbol,
                    dimAccountTypes: this.types,
                    relation: isTrans ? this.getRelation() : null
                })
                .then(res => {
                    this.$emit("success")
                });
        }
    }
    // 判断是否可确定
    isDisable() {
        let keys = Object.keys(this.assModels);
        for (let i = 0; i < keys.length; i++) {
            if (this.assModels[keys[i]] === null) {
                return true;
            }
        }
        return false;
    }

}
